// extracted by mini-css-extract-plugin
export default {"maxWidthInPc":"1440px","maxSmallWidthInPc":"1024px","xs":"376px","sm":"576px","md":"768px","lg":"992px","xl":"1200px","xxl":"1600px","mainLayout":"style_mainLayout__dF-hb"};